export default __webpack_public_path__ + "static/media/en.2e41bc7d.svg";